(function (Accordion, $, undefined) {

  var bindUIActions = function () {
    $('.js-accordion').on('click',function(){
      $(this).parent().toggleClass('is-active');
      return !IsMobile.check();
    });

    $('.article-wrapper-wide').on('click',function(){
      $(this).addClass('is-active');
      console.log('click');
    });
  };

  Accordion.init = function () {
    bindUIActions();
  };

}(window.Accordion = window.Accordion || {}, jQuery));
